import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getFoldersByTenantId = createWrappedAsyncThunk(
  "spreadsheet/getFoldersByTenantId",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get(`spreadsheet/file-folder`, {
      params: {
        tenant_id,
        type: "foldersWithWorkbooks",
      },
    });
    return { tenant_id, data };
  },
);

export const addEditFileFolder = createWrappedAsyncThunk(
  "spreadsheet/addEditFileFolder",
  async (payload) => {
    return await httpClient.post(`spreadsheet/manage`, payload);
  },
);
